import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";
import { fetchUserStudents } from "@/lib/server/fetch-user-students";

export async function prefetchUserStudentsGet(
  id: number,
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching user students");
  }

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.UserStudentsGet, id],
    queryFn: () => fetchUserStudents(id, accessToken),
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}
